/**
 * @name ethernet-port
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgOHYxIiAvPgogIDxwYXRoIGQ9Ik0xNCA4djEiIC8+CiAgPHBhdGggZD0iTTE4IDh2MSIgLz4KICA8cGF0aCBkPSJNMTkgMTdhMiAyIDAgMDAtMS43NjUgMS4wNTlsLS40Ny44ODJBMiAyIDAgMDExNSAyMEg5YTIgMiAwIDAxLTEuNzY1LTEuMDU5bC0uNDctLjg4MkEyIDIgMCAwMDUgMTdINGEyIDIgMCAwMS0yLTJWNmEyIDIgMCAwMTItMmgxNmEyIDIgMCAwMTIgMnY5YTIgMiAwIDAxLTIgMnoiIC8+CiAgPHBhdGggZD0iTTYgOHYxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/ethernet-port
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const EthernetPort: string = `
<svg
  class="lucide lucide-ethernet-port"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 8v1" />
  <path d="M14 8v1" />
  <path d="M18 8v1" />
  <path d="M19 17a2 2 0 00-1.765 1.059l-.47.882A2 2 0 0115 20H9a2 2 0 01-1.765-1.059l-.47-.882A2 2 0 005 17H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v9a2 2 0 01-2 2z" />
  <path d="M6 8v1" />
</svg>
`;

export default EthernetPort;
